/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactDOM from 'react-dom';
import { GalleryComponent, GalleryData, NormaImage } from './Gallery';

function isImage(img: any): img is NormaImage {
    return !!img && typeof img.src === 'string';
}

function prepareGalleryData(data: any[]): GalleryData {
    return data.filter((imgObj: any) => {
        return imgObj && isImage(imgObj.desktop) && isImage(imgObj.tablet) && isImage(imgObj.mobile);
    });
}

const WITHOUT_MOBILE_NAVIGATION_CLASS = 'without-mobile-navigation';

export function initGallery(element: HTMLDivElement): void {
    const data: unknown = JSON.parse(element.querySelector('script')!.innerHTML);
    if (!Array.isArray(data)) return;
    const galleryData = prepareGalleryData(data);
    if (galleryData.length <= 1) element.classList.add(WITHOUT_MOBILE_NAVIGATION_CLASS);
    ReactDOM.render(React.createElement(GalleryComponent, { data: galleryData }), element);
}
